import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const chapterTypeApi = generateNomenApi(`/nomen/chapter-type`);

export const chapterTypeOptions = generateNomenOptions('chapter-type', chapterTypeApi);
